import { createFileRoute, Link } from '@tanstack/react-router'
import { NAVIGATION_ICONS } from './-components/shared/navigation-config'
import { useLingui } from '@lingui/react/macro'
import { ReportComponent } from '@/routes/_app/-components/report/report'
import { Logo } from './-components/shared/logo'
import { useAppStore } from '@/lib/app-store'
import { Animate } from './-components/animate'
import { PageLayout, ScrollableContent, ScrollableArea } from './-components/shared/layout'
import { BreadcrumbTrail } from './-components/title-section'
import { ReportPaneSkeleton } from './-components/app-layout-skeleton'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'
import { clearProfileSelection } from '@/hooks/use-root-search'

export const Route = createFileRoute('/_app/report')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params, true)
  },
  component: RouteComponent,
  pendingComponent: ReportPanePending,
})

function ReportPanePending() {
  return (
    <Animate className="h-full">
      <ReportPaneSkeleton />
    </Animate>
  )
}

function RouteComponent() {
  const { t } = useLingui()
  const extension = useAppStore((state) => state.store.extension)
  const callback = useAppStore((state) => state.store.callback)
  // Access (a company-view employee has no personal report → /jobs) is enforced centrally by the `_app`
  // layout guard (see route-access), before this route's gated `getReport` query ever mounts.

  // Build breadcrumbs
  const breadcrumbs = [
    {
      label: t`My report`,
      link: (
        <Link
          to="/report"
          search={(prev) => ({
            ...clearProfileSelection(prev),
          })}
        >
          {t`My report`}
        </Link>
      ),
    },
  ]

  return (
    <>
      <div id="report" className="@container flex h-full flex-col">
        {extension && <Logo openInNewTab />}
        <PageLayout
          icon={NAVIGATION_ICONS.report}
          title={t`My report`}
          breadcrumbsSlot={<BreadcrumbTrail items={breadcrumbs} />}
        >
          <ScrollableContent>
            <ScrollableArea>
              <ReportComponent callback={callback} />
            </ScrollableArea>
          </ScrollableContent>
        </PageLayout>
      </div>
    </>
  )
}
